import PhotoList, { PhotoListProps } from './PhotoList';

export default PhotoList;
export type { PhotoListProps };
